<template>
  <div>
    <new-line-recharge></new-line-recharge>
  </div>
</template>

<script>
import newLineRecharge from './new-line-recharge.vue';

export default {
  components: {
    newLineRecharge
  }
};
</script>

<style lang="scss" scoped></style>
